import * as ambassadorWixPaymentsMcpV1WixPaymentsAccount from './payments-mcp-v1-wix-payments-account-wix-payments-account.http.js';
import * as ambassadorWixPaymentsMcpV1WixPaymentsAccountTypes from './payments-mcp-v1-wix-payments-account-wix-payments-account.types.js';
import * as ambassadorWixPaymentsMcpV1WixPaymentsAccountUniversalTypes from './payments-mcp-v1-wix-payments-account-wix-payments-account.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function connectWixPaymentsAccount(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentsMcpV1WixPaymentsAccountUniversalTypes.ConnectWixPaymentsAccountRequest,
  ambassadorWixPaymentsMcpV1WixPaymentsAccountTypes.ConnectWixPaymentsAccountRequest,
  ambassadorWixPaymentsMcpV1WixPaymentsAccountUniversalTypes.ConnectWixPaymentsAccountResponse,
  ambassadorWixPaymentsMcpV1WixPaymentsAccountTypes.ConnectWixPaymentsAccountResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsMcpV1WixPaymentsAccount.connectWixPaymentsAccount(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/wix-payments-account/connect',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function connectWixPaymentsAccountBase44(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentsMcpV1WixPaymentsAccountUniversalTypes.ConnectWixPaymentsAccountBase44Request,
  ambassadorWixPaymentsMcpV1WixPaymentsAccountTypes.ConnectWixPaymentsAccountBase44Request,
  ambassadorWixPaymentsMcpV1WixPaymentsAccountUniversalTypes.ConnectWixPaymentsAccountBase44Response,
  ambassadorWixPaymentsMcpV1WixPaymentsAccountTypes.ConnectWixPaymentsAccountBase44Response
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsMcpV1WixPaymentsAccount.connectWixPaymentsAccountBase44(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/wix-payments-account/connect-base44',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setupBase44Site(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentsMcpV1WixPaymentsAccountUniversalTypes.SetupBase44SiteRequest,
  ambassadorWixPaymentsMcpV1WixPaymentsAccountTypes.SetupBase44SiteRequest,
  ambassadorWixPaymentsMcpV1WixPaymentsAccountUniversalTypes.SetupBase44SiteResponse,
  ambassadorWixPaymentsMcpV1WixPaymentsAccountTypes.SetupBase44SiteResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsMcpV1WixPaymentsAccount.setupBase44Site(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/wix-payments-account/setup-base44-site',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  WixPaymentsAccount as WixPaymentsAccountOriginal,
  TermsOfServiceAcceptance as TermsOfServiceAcceptanceOriginal,
  ConnectWixPaymentsAccountRequest as ConnectWixPaymentsAccountRequestOriginal,
  ConnectWixPaymentsAccountResponse as ConnectWixPaymentsAccountResponseOriginal,
  ConnectWixPaymentsAccountBase44Request as ConnectWixPaymentsAccountBase44RequestOriginal,
  Base44AppData as Base44AppDataOriginal,
  ConnectWixPaymentsAccountBase44Response as ConnectWixPaymentsAccountBase44ResponseOriginal,
  Base44Metadata as Base44MetadataOriginal,
  SetupBase44SiteRequest as SetupBase44SiteRequestOriginal,
  SetupBase44SiteResponse as SetupBase44SiteResponseOriginal,
  ConnectWixPaymentsAccountBase44ApplicationErrors as ConnectWixPaymentsAccountBase44ApplicationErrorsOriginal,
} from './payments-mcp-v1-wix-payments-account-wix-payments-account.types.js';
